import Panel from '@admin/components/panel'
import TeamToken from '@admin/tokens/team'
import React from 'react'
import New from './new'

const mapPropsToPanel = (props, context) => ({
  title: 'Affilates',
  collection: {
    endpoint: '/api/admin/truevail/admin/affiliates',
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Affilate)', key: 'team.title', sort: 'team', primary: true, format: (affiliate) => (
        <TeamToken { ..._.omit(affiliate.team, 'is_active') } />
      ) },
      { label: 't(Active Referrals)', key: 'active_referrals_count', collapsing: true, align: 'right', format: (affiliate) => (
        <>{ affiliate.active_referrals_count } / { affiliate.referrals_count }</>
      ) }
    ],
    defaultSort: { key: 'created_at', order: 'desc' },
    empty: {
      title: 't(No Affiliates)',
      text: 't(There are no affiliates)',
      svg: 'heart_handshake',
      buttons: [
        {
          label: 't(Create New Affiliate)',
          modal: New
        }
      ]
    },
    entity: 'affiliate',
    recordTasks: (record) => [
      {
        label: 't(Delete Affiliate)',
        svg: 'trash',
        confirm: 't(Are you sure you want to delete this affiliate?)',
        deletable: true,
        request: {
          endpoint: `/api/admin/truevail/admin/affiliates/${record.id}`,
          method: 'DELETE',
          onSuccess: () => context.flash.set('success', 't(Successfully deleted affiliate)'),
          onFailure: () => context.flash.set('error', 't(Unable to delete affiliate)')
        }
      }
    ],
    onClick: (record) => context.router.push(`/admin/truevail/admin/affiliates/${record.id}`)
  },
  task: {
    svg: 'plus',
    modal: New
  }
})

export default Panel(null, mapPropsToPanel)
